 import axios from 'axios';
 import { getApiUrl } from './domainConfig';

 const axiosServices = axios.create();
const inFlightRequests = new Map();

const stableStringify = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value !== 'object') return String(value);
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`;
  return `{${Object.keys(value)
    .sort()
    .map((k) => `${k}:${stableStringify(value[k])}`)
    .join(',')}}`;
};

const requestKeyFromConfig = (config) => {
  const method = String(config?.method || 'get').toLowerCase();
  const url = String(config?.url || '');
  const params = stableStringify(config?.params);
  const data = typeof config?.data === 'string' ? config.data : stableStringify(config?.data);
  return `${method}|${url}|${params}|${data}`;
};

 // Request interceptor for adding token and dynamic API URL
 axiosServices.interceptors.request.use(
   (config) => {
     const token = localStorage.getItem('supplierToken');
     if (token) {
       config.headers.Authorization = `Bearer ${token}`;
     }
     
    // URL'i domain'e göre dönüştür
    if (config.url && typeof config.url === 'string') {
      const envApiUrl = import.meta.env.VITE_REACT_APP_APIURL;
      
      // Eğer URL'de env API URL'i varsa, domain'e göre değiştir
      if (envApiUrl && config.url.includes(envApiUrl)) {
        // Path'i çıkar
        const path = config.url.replace(envApiUrl, '');
        // Domain'e göre yeni URL oluştur
        config.url = getApiUrl(path);
      } 
      // Mobilassistance domain'lerini yakala ve domain'e göre dönüştür
      else if (config.url.includes('mobilassistance.com') || config.url.includes('appuat.mobilassistance')) {
        try {
          const urlObj = new URL(config.url);
          const path = urlObj.pathname + urlObj.search;
          // Domain'e göre yeni URL oluştur
          config.url = getApiUrl(path);
        } catch (e) {
          // URL parse edilemezse, path'i direkt al
          const pathMatch = config.url.match(/(\/[^?]*)/);
          if (pathMatch) {
            config.url = getApiUrl(pathMatch[1] + (config.url.includes('?') ? config.url.substring(config.url.indexOf('?')) : ''));
          }
        }
      } 
      // Tam URL ise (diğer domain'ler), sadece path'i al ve domain'e göre yeniden oluştur
      else if (config.url.startsWith('http://') || config.url.startsWith('https://')) {
        try {
          const urlObj = new URL(config.url);
          const path = urlObj.pathname + urlObj.search;
          config.url = getApiUrl(path);
        } catch (e) {
          // URL parse edilemezse olduğu gibi bırak
        }
      } 
      // Relative path ise, domain'e göre tam URL oluştur
      else {
        config.url = getApiUrl(config.url);
      }
    }
     
    const dedupeEnabled = config?.meta?.dedupe !== false;
    if (!dedupeEnabled) {
      return config;
    }
    const requestKey = requestKeyFromConfig(config);
    const baseAdapter = config.adapter || axios.defaults.adapter;
    if (typeof baseAdapter === 'function') {
      config.adapter = async (cfg) => {
        const existing = inFlightRequests.get(requestKey);
        if (existing) {
          return existing;
        }
        const requestPromise = Promise.resolve(baseAdapter(cfg)).finally(() => {
          inFlightRequests.delete(requestKey);
        });
        inFlightRequests.set(requestKey, requestPromise);
        return requestPromise;
      };
      config.meta = { ...(config.meta || {}), requestKey };
    }
    return config;
   },
   (error) => Promise.reject(error)
 );

 // Response interceptor
 axiosServices.interceptors.response.use(
   (response) => response,
   (error) => {
     // Handle 401 Unauthorized errors
     if (error.response && error.response.status === 401) {
       localStorage.removeItem('supplierToken');
       localStorage.removeItem('idSupplier');
       localStorage.removeItem('supplierRedirectUrl');
       window.location.href = '/supplier/check';
     }
     return Promise.reject((error.response && error.response.data) || 'Wrong Services');
   }
 );

 export default axiosServices;
 